import React from 'react';

const statusMap = {
    pending: { variant: 'secondary', label: 'Pending' },
    sending: { variant: 'warning', label: 'Sending' },
    paused: { variant: 'info', label: 'Paused' },
    completed: { variant: 'success', label: 'Completed' },
    failed: { variant: 'danger', label: 'Failed' },
    cancelled: { variant: 'dark', label: 'Cancelled' },
};

const EmailBroadcastStatusBadge = ({ status }) => {
    const config = statusMap[status] || statusMap.pending;
    return <span className={`badge badge-${config.variant}`}>{config.label}</span>;
};

export default EmailBroadcastStatusBadge;
export { statusMap };
